import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['address', 'area1', 'area2', 'area3', 'errorAddress', 'errorArea1', 'submitButton']

  connect() {
    this.duplicateSelect()
    this.controllSubmitButton()
  }

  duplicateSelect() {
    // 選択された値を取得
    const selectedValues = new Set(
      [this.area1Target, this.area2Target, this.area3Target]
        .map(select => select.value)
        .filter(value => value !== '' && value !== '0') // 空 or 「こだわらない」以外をセット
    );

    // 各セレクトボックスの選択肢を制御
    [this.area1Target, this.area2Target, this.area3Target].forEach(select => {
      Array.from(select.options).forEach(option => {
        if (option.value !== '' && option.value !== '0') {
          option.disabled = selectedValues.has(option.value) && select.value !== option.value || option.value == 'area';
        }
      });
    });
  }

  validateAddress() {
    this.errorAddressTarget.classList.add('regist_form__hide')

    const isAddressInvalid = this.addressTarget.value == ''
    this.addressTarget.classList.toggle('regist_form__error_input', isAddressInvalid)
    this.errorAddressTarget.classList.toggle('regist_form__hide', !isAddressInvalid)
  }

  validateArea1() {
    this.errorArea1Target.classList.add('regist_form__hide')

    const isArea1Invalid = this.area1Target.value == ''
    this.area1Target.classList.toggle('regist_form__error_input', isArea1Invalid)
    this.errorArea1Target.classList.toggle('regist_form__hide', !isArea1Invalid)
  }

  controllSubmitButton() {
    const isAddressInvalid = this.addressTarget.value == '';
    const isArea1Invalid = this.area1Target.value == '';

    const isFormInvalid = isAddressInvalid || isArea1Invalid;
    this.submitButtonTarget.disabled = isFormInvalid;
    this.submitButtonTarget.classList.toggle('regist_form__button--disabled', isFormInvalid);
  }
}
